<template>
  <div class="conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide =! hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide =! hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
        </el-col>
      </el-row>
        <el-collapse-transition>
          <div v-show="hide" class="search-content common-search-formtype">
            <el-form :inline="true" :model="formInlineTmp" class="search-content-item">
              <el-form-item label="输入搜索：">
                <el-input @keyup.enter.native="searchLoad" v-model.trim="formInline.name" placeholder="请输入客户来源" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
    </div>
    <el-container>
      <el-main style="padding: 0" class="table-first-style">
        <el-row  class="search-title common-table-top" style="padding-right:0">
          <el-col :span="4" class="table-title">
            <i class="el-icon-document" style="font-weight: bold;"></i>
            <span>属性列表</span>
          </el-col>
          <el-col :span="20" class="text-align-right">
            <el-button type="primary" v-show="btnType.add" class="add-btn btn-right" @click="openDialog">添加</el-button>
          </el-col>
        </el-row>
        <el-table ref="multipleTable" :data="tableData" class="table" v-loading="loading">
          <template slot="empty">
            <div class="newTableEmpty">暂无数据，去<span @click="openDialog">新建</span></div>
          </template>
          <el-table-column prop="name" label="来源" width=""></el-table-column>
          <el-table-column label="创建时间" >
            <template slot-scope="scope">
              {{ scope.row.createTimeStr }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" style="display: flex;justify-content: center">
            <template slot-scope="scope">
              <div v-if="scope.row.isSystem === 0" v-show="btnType.edit" class="op-link editColor" @click="edit(scope.row)">
                编辑
              </div>
              <div class="op-link deleteColor" v-if="scope.row.isSystem === 0" v-show="btnType.del" @click="deleteThis(scope.row)">
                删除
              </div>
              <div v-if="scope.row.isSystem === 1">--</div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>

    <div class="table-foot">
      <el-pagination
        class="table-foot-pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="limit"
        layout="total, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>

    <!--添加弹窗-->
    <el-dialog class="cellDialog base-dialog" title="来源设置" :visible.sync="adddialog" width="520px">
      <el-form ref="addForm" :model="addForm" :rules="rules">
        <el-form-item label="来源名称:" :label-width="addLabelWidth" prop="name">
          <el-input class="stockInput" type="text" v-model="addForm.name" auto-complete="off" placeholder="输入来源名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="adddialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button :disabled="disabled" class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="submitForm('addForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addCustomerSource, editCustomerSource, deleteCustomerSource } from '@/api/customer.js'
import { getCustomerSources, addCustomerSources, editCustomerSources, deleteCustomerSources } from '@/api/set.js'
import { butonsList,getMenId } from '@/api/analyse.js'
export default {
  name: 'customerSource',
  data () {
    return {
      disabled: false,
      formInlineTmp: {},
      hide: true,
      loading: true,
      tableData: [],
      limit: 10,
      totalCount: 0,
      adddialog: false,
      addForm: {
        name: ''
      },
      addLabelWidth: '80px',
      dialogType: 0,
      editId: '',
      page: 1,
      formInline: {
        name: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入来源名称', trigger: 'blur' }
        ]
      },
      btnType:{
        'add':false,
        'edit':false,
        'del':false
      }
    }
  },
  methods: {
    searchLoad() {
      this.page = 1
      this.load()
    },
    queryBtnList(){
      var itemId = getMenId(this.$route.path)
       butonsList({systemCode: 'ZY_INTELLIQUOR',menuId:itemId})
        .then((res)=>{
          if(res.data.code == '200'){
            var btnList = this.btnType
            for(let i = 0, k = res.data.result.length; i < k; i ++){
              for(let m in btnList){
                if(res.data.result[i].perms.indexOf(m) != -1){
                  this.btnType[m] = true
                }
              }
            }
          }
        })
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.load()
    },
    handleCurrentChange(page) {
      this.page = page
      this.load()
    },
    // 加载列表
    load() {
      this.loading = true
      getCustomerSources(this.page, this.limit, this.formInline.name).then((res) => {
        console.log(res)
        if (res.data.code == 200) {
          this.tableData = res.data.result.list
          this.totalCount = res.data.result.total
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 删除
    deleteThis(item) {
      this.$confirm('确认删除该来源?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCustomerSources(item.id).then((res) => {
          if (res.data.code == 200) {
            this.load()
            _g.toastMsg('success', '删除成功')
          }
        })
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAdd()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 弹窗确定
    confirmAdd() {
      this.disabled = true
      // 添加弹窗
      if (this.dialogType === 1) {
        addCustomerSources(this.addForm.name).then((res) => {
          if (res.data.code == 200) {
            this.adddialog = false
            this.disabled = false
            this.addForm.name = ''
            this.load()
            _g.toastMsg('success', '添加成功')
          } else {
            this.disabled = false
            _g.toastMsg('error', res.data.message)
          }
        })
      }
      // 编辑弹窗
      if (this.dialogType === 2) {
        editCustomerSources(this.addForm.name, this.editId).then((res) => {
          if (res.data.code == 200) {
            this.adddialog = false
            this.disabled = false
            this.addForm.name = ''
            this.load()
            _g.toastMsg('success', '编辑成功')
          } else {
            this.disabled = false
            _g.toastMsg('error', res.data.message)
          }
        })
      }
    },
    // 打开添加弹窗
    openDialog() {
      this.adddialog = true
      this.dialogType = 1
      this.addForm.name = ''
    },
    // 打开编辑弹窗
    edit(item) {
      this.adddialog = true
      this.dialogType = 2
      this.addForm.name = item.name
      this.editId = item.id
    }
  },
  created() {
    this.load()
    this.queryBtnList()
  }
}
</script>

<style scoped>

  .table-title{
    text-align: left;
  }
</style>
